export default (t) => [
  {
    text: t('Group Name'),
    value: 'name',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Products'),
    value: 'products',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Selection Type'),
    value: 'select_type',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Recipe Behavior'),
    value: 'recipe_behavior',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Required Status'),
    value: 'required',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Option Count'),
    value: 'options_count',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Out of stock at'),
    value: 'out_of_stock_branches',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Disabled at'),
    value: 'inactive_branches',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Tags'),
    value: 'tags',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 100,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 20
  },
];
